// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.revisions-list__label {
  display: inline-block;
  vertical-align: top;
  padding: 0 8px;
  margin: 0 0 8px 20px;
  box-sizing: border-box;
  border: 1px solid transparent;
  background-color: var(--g-color-base-background);
  border-radius: 4px;
  line-height: 20px;
  color: var(--g-color-text-secondary);
  font-size: var(--g-text-body-1-font-size);
  position: relative;
}
.revisions-list__label:after {
  content: "";
  position: absolute;
  border-left: 1px solid var(--g-color-line-generic-accent);
  width: 0;
  height: 8px;
  top: calc(20px + 1px);
  left: 12px;
}
.revisions-list__content {
  margin: 0;
  padding: 0;
}
.revisions-list__row {
  list-style: none;
  margin: 0;
  padding: 8px 20px 8px 50px;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  z-index: 1;
  cursor: pointer;
  transition: background-color 0.21s ease-out;
  color: var(--g-color-text-complementary);
}
.revisions-list__row:before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 33px;
  border-left: 1px solid var(--g-color-line-generic-accent);
  z-index: 1;
}
.revisions-list__row:hover {
  background-color: var(--g-color-base-simple-hover);
}
.revisions-list__row_disabled, .revisions-list__row_disabled:hover {
  background-color: initial;
  opacity: 0.5;
}
.revisions-list__row_current, .revisions-list__row_current:hover {
  background-color: var(--g-color-base-selection);
}
.revisions-list__row-actions {
  margin-inline: auto 0;
  visibility: hidden;
}
.revisions-list__row:hover .revisions-list__row-actions {
  visibility: visible;
}
.revisions-list__row .revisions-list__point-wrap {
  position: absolute;
  left: 26px;
  top: 14px;
  z-index: 1;
}
.revisions-list__text {
  margin-top: 6px;
  color: var(--g-color-text-primary);
  font-size: var(--g-text-body-1-font-size);
  line-height: var(--g-text-body-1-line-height);
}
.revisions-list__block:last-child .revisions-list__row:last-child {
  margin-bottom: 0;
}
.revisions-list__block:last-child .revisions-list__row:last-child:before {
  bottom: calc(20px + 2px);
}
.revisions-list__block + .revisions-list__block .revisions-list__label {
  margin-top: 8px;
}
.revisions-list__block + .revisions-list__block .revisions-list__label:before {
  content: "";
  position: absolute;
  border-left: 1px solid var(--g-color-line-generic-accent);
  width: 0;
  height: 8px;
  top: calc(-8px - 1px);
  left: 12px;
}
.revisions-list__avatar {
  margin-right: 18px;
}
.revisions-list__point-tooltip {
  padding: var(--g-spacing-2) var(--g-spacing-3);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Revisions/RevisionsList/RevisionsList.scss"],"names":[],"mappings":"AAMI;EACI,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,sBAAA;EACA,6BAAA;EACA,gDAAA;EACA,kBAAA;EACA,iBAfM;EAgBN,oCAAA;EACA,yCAAA;EACA,kBAAA;AALR;AAOQ;EACI,WAAA;EACA,kBAAA;EACA,yDAAA;EACA,QAAA;EACA,WAxBE;EAyBF,qBAAA;EACA,UAAA;AALZ;AASI;EACI,SAAA;EACA,UAAA;AAPR;AAUI;EACI,gBAAA;EACA,SAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,2CAAA;EACA,wCAAA;AARR;AAUQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,yDAAA;EACA,UAAA;AARZ;AAWQ;EACI,kDAAA;AATZ;AAWQ;EAEI,yBAAA;EACA,YAAA;AAVZ;AAaQ;EAEI,+CAAA;AAZZ;AAgBI;EACI,qBAAA;EACA,kBAAA;AAdR;AAiBI;EACI,mBAAA;AAfR;AAkBI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AAhBR;AAmBI;EACI,eAAA;EACA,kCAAA;EACA,yCAAA;EACA,6CAAA;AAjBR;AAoBI;EACI,gBAAA;AAlBR;AAoBQ;EACI,wBAAA;AAlBZ;AAsBI;EACI,eAzGM;AAqFd;AAsBQ;EACI,WAAA;EACA,kBAAA;EACA,yDAAA;EACA,QAAA;EACA,WAhHE;EAiHF,qBAAA;EACA,UAAA;AApBZ;AAwBI;EACI,kBAAA;AAtBR;AAyBI;EACI,8CAAA;AAvBR","sourcesContent":[".revisions-list__label {\n  display: inline-block;\n  vertical-align: top;\n  padding: 0 8px;\n  margin: 0 0 8px 20px;\n  box-sizing: border-box;\n  border: 1px solid transparent;\n  background-color: var(--g-color-base-background);\n  border-radius: 4px;\n  line-height: 20px;\n  color: var(--g-color-text-secondary);\n  font-size: var(--g-text-body-1-font-size);\n  position: relative;\n}\n.revisions-list__label:after {\n  content: \"\";\n  position: absolute;\n  border-left: 1px solid var(--g-color-line-generic-accent);\n  width: 0;\n  height: 8px;\n  top: calc(20px + 1px);\n  left: 12px;\n}\n.revisions-list__content {\n  margin: 0;\n  padding: 0;\n}\n.revisions-list__row {\n  list-style: none;\n  margin: 0;\n  padding: 8px 20px 8px 50px;\n  position: relative;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  z-index: 1;\n  cursor: pointer;\n  transition: background-color 0.21s ease-out;\n  color: var(--g-color-text-complementary);\n}\n.revisions-list__row:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 33px;\n  border-left: 1px solid var(--g-color-line-generic-accent);\n  z-index: 1;\n}\n.revisions-list__row:hover {\n  background-color: var(--g-color-base-simple-hover);\n}\n.revisions-list__row_disabled, .revisions-list__row_disabled:hover {\n  background-color: initial;\n  opacity: 0.5;\n}\n.revisions-list__row_current, .revisions-list__row_current:hover {\n  background-color: var(--g-color-base-selection);\n}\n.revisions-list__row-actions {\n  margin-inline: auto 0;\n  visibility: hidden;\n}\n.revisions-list__row:hover .revisions-list__row-actions {\n  visibility: visible;\n}\n.revisions-list__row .revisions-list__point-wrap {\n  position: absolute;\n  left: 26px;\n  top: 14px;\n  z-index: 1;\n}\n.revisions-list__text {\n  margin-top: 6px;\n  color: var(--g-color-text-primary);\n  font-size: var(--g-text-body-1-font-size);\n  line-height: var(--g-text-body-1-line-height);\n}\n.revisions-list__block:last-child .revisions-list__row:last-child {\n  margin-bottom: 0;\n}\n.revisions-list__block:last-child .revisions-list__row:last-child:before {\n  bottom: calc(20px + 2px);\n}\n.revisions-list__block + .revisions-list__block .revisions-list__label {\n  margin-top: 8px;\n}\n.revisions-list__block + .revisions-list__block .revisions-list__label:before {\n  content: \"\";\n  position: absolute;\n  border-left: 1px solid var(--g-color-line-generic-accent);\n  width: 0;\n  height: 8px;\n  top: calc(-8px - 1px);\n  left: 12px;\n}\n.revisions-list__avatar {\n  margin-right: 18px;\n}\n.revisions-list__point-tooltip {\n  padding: var(--g-spacing-2) var(--g-spacing-3);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
